module.exports = __webpack_public_path__ + "static/media/Group.cc6bc539.svg";